import { Form } from 'antd';
import ModalConfirm, { useModalConfirmRef } from 'components/Modal/ModalConfirm';
import styled from 'styled-components';
import ModalEditTurnServiceName, { useModalEditTurnServiceNameRef } from './ModalEditName';
import TurnColorItem from './TurnColorItem';
import ModalChangeColor, { useModalChangeColorRef } from '../ModalChangeColor';
type Props = {
  onClose: () => void;
};
const TurnSettingColors = ({ onClose }: Props) => {
  const modalConfirm = useModalConfirmRef();
  const modalChangeColor = useModalChangeColorRef();
  const editNameRef = useModalEditTurnServiceNameRef();

  const handleChangeColor = (value: string, onChange: (value: string) => void) => {
    modalChangeColor.current?.open(value, onChange);
  };

  return (
    <>
      <Wrapper>
        <ContentContainer>
          <div className="scroll-div">
            <Form.List name={'colors'}>
              {(fields) => <Container>
                {fields.map((o) => <Form.Item noStyle name={o.name} key={o.key}>
                  <TurnColorItem
                    onEdit={handleChangeColor} />
                </Form.Item>)}
              </Container>}
            </Form.List>
          </div>
        </ContentContainer>
        <Footer>
          <button onClick={onClose} type='button' className="btn btn-close"><span>Close</span></button>
          <button type='submit' className="btn btn-submit"><span>Update</span></button>
        </Footer>
      </Wrapper>
      <ModalEditTurnServiceName ref={editNameRef} />
      <ModalConfirm ref={modalConfirm} />
      <ModalChangeColor ref={modalChangeColor} />
    </>
  );
};

export default TurnSettingColors;

const ContentContainer = styled.div`
  flex: 1;
  position: relative;
`;
const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const Container = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
  padding: 16px 24px;
`;

const Footer = styled.div`
display: flex;
padding: 24px;
align-items: flex-start;
gap: 16px;
align-self: stretch;
background: #FFF;
box-shadow: 0px -4px 8px -4px rgba(0, 0, 0, 0.25);
button.btn {
  display: flex;
  height: 56px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 5px;
  border: 1px solid #86909C;
  background: #E5E6EB;
  span {
    color: #1D2129;
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px; /* 166.667% */
    text-transform: uppercase;
  }

  &.btn-delete {
    border: 1px solid #F53F3F;
    background: #FFF;
    span {
      color: #F53F3F;
    }
  }
  &.btn-add-turn {
    border: 1px solid #2D6772;
    background: #FFF;
    span {
      color: #2D6772;
    }
  }
  &.btn-submit {
    border-radius: 5px;
    background: #C52884;
    border: 1px solid #C52884;
    span {
      color: #fff;
    }
  }
}
`;
